import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ConversationBitrix } from '@chatapp-inbox/shared';
import { getConversationBitrix, syncConversationBitrix } from '../../api';
import { conversationBitrixKey } from '../conversation';

/** Enquanto há conferência na fila, a tela pergunta de novo a cada tanto (o resultado sai em segundos). */
export const BITRIX_POLL_MS = 3000;

/**
 * O Lead da conversa no Bitrix. Fica desatualizado em 30 s; o tempo real invalida quando chega uma mensagem
 * do cliente (que pode criar ou trocar o Lead), e enquanto há conferência na fila a consulta se repete.
 */
export function useConversationBitrix(conversationId: string) {
  return useQuery({
    queryKey: conversationBitrixKey(conversationId),
    queryFn: ({ signal }) => getConversationBitrix(conversationId, signal),
    staleTime: 30_000,
    refetchInterval: (query) => {
      const data = query.state.data as ConversationBitrix | undefined;
      return data && (data.state === 'pending' || data.rechecking) ? BITRIX_POLL_MS : false;
    },
  });
}

/** "Verificar de novo": enfileira a conferência e já mostra "conferindo…". */
export function useSyncBitrix(conversationId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => syncConversationBitrix(conversationId),
    onSuccess: (bitrix) => {
      queryClient.setQueryData(conversationBitrixKey(conversationId), bitrix);
    },
  });
}
